import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const NavContainer = styled.nav`
  display: flex;
  gap: 2px;
  padding: 0 2rem;
  padding-top: 2rem;
  background-color: ${({ theme }) => theme.colors.manila};
  position: relative;
  z-index: 100;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 768px) {
    padding: 0 1rem;
    padding-top: 1rem;
    gap: 1px;
  }

  @media (max-width: 480px) {
    padding: 0 0.5rem;
    padding-top: 0.75rem;
  }

  /* Hide scrollbar but keep functionality */
  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #F5EFE3;
  }

  &::-webkit-scrollbar-thumb {
    background: #C4B5A0;
    border-radius: 2px;
  }
`;

const FolderTab = styled(NavLink)`
  position: relative;
  padding: 0.75rem 2rem;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.ink};
  background: linear-gradient(to bottom, #F5EFE3 0%, #FAF3E8 50%);
  border: 1.5px solid #C4B5A0;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.2s ease;
  box-shadow: 
    inset 0 1px 0 rgba(255, 255, 255, 0.6),
    1px -1px 3px rgba(0, 0, 0, 0.06);
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background: linear-gradient(to bottom, #F8F2E6 0%, #FDF9F0 50%);
    transform: translateY(-2px);
  }

  &.active {
    background: #FAF3E8;
    z-index: 10;
    padding-bottom: 1rem;
    margin-bottom: -2px;
    box-shadow: 
      inset 0 2px 0 rgba(255, 255, 255, 0.8),
      2px -2px 5px rgba(0, 0, 0, 0.08);
  }

  /* Stamped/distressed text effect */
  text-shadow: 1px 1px 0px rgba(255, 255, 255, 0.4);

  @media (max-width: 768px) {
    padding: 0.6rem 1.25rem;
    font-size: 0.8rem;
    letter-spacing: 0.3px;

    &.active {
      padding-bottom: 0.9rem;
    }
  }

  @media (max-width: 480px) {
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
    letter-spacing: 0.2px;

    &.active {
      padding-bottom: 0.8rem;
    }
  }
`;

const TabLabel = styled.span`
  position: relative;
  display: inline-block;
`;

function Navigation() {
  const tabs = [
    { path: '/', label: 'Search' },
    { path: '/people', label: 'People' },
    { path: '/stats', label: 'Stats' },
    { path: '/explorer', label: 'Explorer' },
    { path: '/timeline', label: 'Timeline' },
  ];

  return (
    <NavContainer>
      {tabs.map((tab) => (
        <FolderTab
          key={tab.path}
          to={tab.path}
          end={tab.path === '/'}
        >
          <TabLabel data-label={tab.label}>{tab.label}</TabLabel>
        </FolderTab>
      ))}
    </NavContainer>
  );
}

export default Navigation;

